import { useCallback, useMemo } from "react";

import { Container } from "@material-ui/core";

import { ContentSection } from "../../layout/ContentSection";
import { GardenerInformationDueDiligenceTaskDocument } from "../../task/task.model";
import { ListSection, ListSectionProps } from "../../components/admin-list-section/ListSection";
import { sortbyDueDateThenGardenerThenType } from "../../shared/utility";
import { formatAction, formatActionDate } from "../shared/utility";

type Task = GardenerInformationDueDiligenceTaskDocument;

interface AutomaticTabProps {
    tasks: Task[];
    goToTask: (task: Task) => void;
}

export const AutomaticTab = (props: AutomaticTabProps) => {
    const { tasks, goToTask } = props;

    const relevantTaskListItems: ListSectionProps["items"] = useMemo(() => {
        return tasks.sort(sortbyDueDateThenGardenerThenType).map(mapToListItem);
    }, [tasks]);

    const goToRelevantTask = useCallback((index: number) => {
        const task = tasks[index];

        goToTask(task);
    }, [goToTask, tasks]);

    return (
        <ContentSection>
            <Container maxWidth="sm" disableGutters>

                <ListSection
                    title="Automatisk håndtering"
                    placeholder="Der er ingen opgaver til automatisk håndtering"
                    items={relevantTaskListItems}
                    onClick={goToRelevantTask}
                />

            </Container>
        </ContentSection>
    );
};

const mapToListItem = (task: Task): ListSectionProps["items"][0] => {
    const date = formatActionDate(task);
    const subtype = formatAction(task);

    return {
        heading: `${task.gardenerName}, ${subtype}`,
        subheading: `Skal udføres ${date}`,
    };
}
